export const escapeHtml = value => {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

export const shouldShowProductPrices = () => {
    if (typeof ajax === 'undefined') {
        return false;
    }

    return ajax.showProductPrices !== false && ajax.showProductPrices !== 0;
};

export const formatPlnPrice = value =>
    `${Number(value).toFixed(2).replace('.', ',')} zł`;

export const formatElasticPriceHtml = product => {
    if (!shouldShowProductPrices()) {
        return '';
    }
    const priceLabel = String(product?.price_label || '').trim();

    if (priceLabel !== '') {
        return escapeHtml(priceLabel);
    }

    const priceFrom = Number(product?.price_from);

    if (Number.isFinite(priceFrom) && priceFrom > 0) {
        const formatted = new Intl.NumberFormat('pl-PL', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(priceFrom);
        const showPriceFrom = Boolean(product?.listing_show_price_from);
        const priceText = showPriceFrom
            ? `od ${formatted} zł`
            : `${formatted} zł`;

        return escapeHtml(priceText);
    }

    const regular = Number(product.regular_price);
    const sale = Number(product.sale_price);

    if (Number.isFinite(sale) && sale > 0) {
        return escapeHtml(formatPlnPrice(sale));
    }

    if (Number.isFinite(regular) && regular > 0) {
        return escapeHtml(formatPlnPrice(regular));
    }

    return '';
};

export const getPolishCountLabel = (total, labels = {}) => {
    const normalized = Number(total) || 0;
    const mod10 = normalized % 10;
    const mod100 = normalized % 100;

    if (normalized === 1) {
        return labels.singular || 'wynik';
    }

    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) {
        return labels.few || 'wyniki';
    }

    return labels.many || 'wyników';
};
